module.exports = __webpack_public_path__ + "static/media/prop-11@2x.be6f1c9a.png";